import module from 'nominas/nomina/module.js'
import template from './template.html'

export class NominaTimbresListaItemComponent {
  constructor () {
    this.editando = false
    this.data = null
    this.onSelect = null
  }

  seleccionar () {
    if (this.data.pendiente || this.data.bloqueado) return

    this.onSelect()
  }
}

module.component('nominaTimbresListaItem', {
  controller: NominaTimbresListaItemComponent,
  template,
  bindings: {
    data: '<',
    onSelect: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/timbres/lista/item/component.js